import RecordLevelInputValidationInfo from './RecordLevelValidationInfo'

export default RecordLevelInputValidationInfo
